export const getControls = (onCancel, onUntrack) => [
    {
        className: 'hp-horseTracker__cancel ui-btn_hollow',
        label: 'Cancel',
        onClick: onCancel,
    },
    {
        className: 'hp-horseTracker__untrack ui-btn_hollow',
        label: 'Untrack',
        onClick: onUntrack,
    },
];

export const getButtons = (onTrack, onTracked, onCancel) => ({
    track: {
        className: 'hp-horseTracker__track ui-btn_major',
        label: 'Track Horse',
        iconName: 'tracker',
        onClick: onTrack,
    },
    tracked: {
        className: 'hp-horseTracker__tracked ui-btn_hollow',
        label: 'Horse Tracked',
        iconName: 'tick',
        onClick: onTracked,
    },
    active: {
        className:
            'hp-horseTracker__tracked hp-horseTracker__tracked_active ui-btn_hollow',
        label: 'Horse Tracked',
        iconName: 'tick',
        onClick: onCancel,
    },
});

export const errorMessages = {
    track:
        `Something's gone wrong and your horse could
            not be added to Horse Tracker.
            Please check you are signed in and try again.`,
    untrack:
        `Something's gone wrong and your horse could
            not be removed from your Horse Tracker.
            Please check you are signed in and try again.`,
    limit: 'limitError',
};

export const getAjaxUrl = (horseUid, action) => `horse/horse-tracker/ugc/${horseUid}/${action}`;



// WEBPACK FOOTER //
// ./src/js/shared/horseTracker/helpers.js